import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Image from 'components/Image'
import Divider from 'components/Divider'
import { Modal } from 'components/Modal'
import Button from 'components/Button'

import { Label, StyledCard, StyledRow, GoogleLabel, GoogleValue, LinkContainer } from './styled'
import { ReactComponent as QRCode } from './media/qr.svg'
import { ReactComponent as Call } from './media/call.svg'
import { ReactComponent as Web } from './media/web.svg'

const GoogleModalPreview = ({ appData, formData = {} }) => {
	const { logoImg, heroGoogleImg, wideLogoGoogleImg, backgroundColor, programName, accountIdLabel, rewardsTierLabel, rewardsTier, secondaryRewardsTierLabel, secondaryRewardsTier, homepageUri, linkPhoneUri } = formData
	const [showModal, setShowModal] = useState(false)
	const [t] = useTranslation()
	return(
		<>
			<Button text={t('common.strings.preview')} type='button' status='active' onClick={() => setShowModal(true)}/>
			{showModal && <Modal label={t('options_section.strings.wallet_google_preview')} width={723} unmount={() => setShowModal(false)} style={{ display: 'flex' }}>
				<div style={{ margin: 'auto' }}>
					<Label>{t('options_section.strings.card_preview')}</Label>
					<StyledCard height={470} backgroundColor={backgroundColor}>
						<Image style={{ width: '126px', height: '40px', ...!wideLogoGoogleImg && { background: 'rgba(255, 255, 255, 0.5)' } }} src={wideLogoGoogleImg}/>
						<Divider visible height={30} width={300} style={{ margin: '15px -15px' }}/>

						<Label fontSize='22px' fontWeight={300}>{t('options_section.strings.customer_card')}</Label>
						<Divider height={30}/>
						<StyledRow>
							<Label fontSize='10px'>{t('loyalty_card_section.fields.balance')}</Label>
							<Label fontSize='10px'>{formData.programName}</Label>
						</StyledRow>
						<Divider height={5}/>
						<StyledRow>
							<Label fontSize='12px'>{appData.mainCurrency} 0000.0</Label>
							<Label fontSize='12px'>0</Label>
						</StyledRow>
						<Divider height={30}/>
						<QRCode/>
						<Divider height={10}/>
						<Label fontSize='12px' alignSelf='center' fontWeight={300}>{t('options_section.strings.wallet_more_info')}</Label>
						<Divider height={10}/>
						<Image style={{ borderRadius: 'unset', margin: '0 -15px -15px -15px', width: '300px', height: '110px', ...!heroGoogleImg && { background: 'rgba(255, 255, 255, 0.5)' } }} src={heroGoogleImg}/>
					</StyledCard>
				</div>
				<div style={{ margin: 'auto' }}>
					<Label>{t('options_section.strings.cardinfo_preview')}</Label>
					<StyledCard height={470} backgroundColor={backgroundColor}>
						<Image style={{ width: '45px', height: '45px', borderRadius: '50%', ...!logoImg && { background: 'rgba(255, 255, 255, 0.5)' } }} src={logoImg}/>
						<Divider height={30}/>
						<Label fontSize='22px' fontWeight={300}>{t('options_section.strings.customer_card')}</Label>
						<Divider height={20}/>
						<GoogleLabel>{t('loyalty_card_section.fields.card_name')}</GoogleLabel>
						<GoogleValue>{t('options_section.strings.customer_card')}</GoogleValue>
						<Divider height={10}/>
						<GoogleLabel>{t('options_section.fields.vcard_description')}</GoogleLabel>
						<GoogleValue>{accountIdLabel}</GoogleValue>
						<Divider height={20}/>
						<GoogleLabel>{rewardsTierLabel}</GoogleLabel>
						<GoogleValue>{rewardsTier}</GoogleValue>
						<Divider height={20}/>
						<GoogleLabel>{secondaryRewardsTierLabel}</GoogleLabel>
						<GoogleValue>{secondaryRewardsTier}</GoogleValue>
						<Divider height={20}/>
						<GoogleLabel>{t('loyalty_card_section.fields.balance')}</GoogleLabel>
						<GoogleValue>{appData.mainCurrency} 0000.00</GoogleValue>
						<Divider height={20}/>
						<GoogleLabel>{formData.programName}</GoogleLabel>
						<GoogleValue>0</GoogleValue>
						<Divider height={20} visible/>
						{homepageUri?.link ?
							<LinkContainer>
								<Call/>
								<GoogleLabel>{homepageUri?.description}</GoogleLabel>
							</LinkContainer> : null
						}
						{linkPhoneUri?.link ?
							<LinkContainer>
								<Web/>
								<GoogleLabel>{linkPhoneUri?.description}</GoogleLabel>
							</LinkContainer> : null
						}
						<LinkContainer>
							<Web/>
							<GoogleLabel>{t('options_section.strings.wallet_orders_link')}</GoogleLabel>
						</LinkContainer>
					</StyledCard>
				</div>
			</Modal>}
		</>
	)
}

export default GoogleModalPreview